
import { useEffect, useState } from 'react';
import { Cookies } from 'react-cookie';
import "react-datepicker/dist/react-datepicker.css";
import { useNavigate } from "react-router-dom";
import { API_SERVER } from '../../EnvConfig/env_config';
import { getCommonData } from '../Common/CommanServices';
import { Amount, BindGrid, convertToNumber, exportToExcel, setFocus, setTitle } from '../Common/Common';
import { AlertBox, AutoCompleteBox } from '../Common/Input';
import { post } from '../Common/service';
import Loader from '../Layout/Loader';

const CustomerMaster = ({ open,setOpen }) => {
    const cookies = new Cookies();
    const Token = cookies.get('token')
    const navigate = useNavigate();
    const LoginUserCode = cookies.get('loginUserCode').toString();
    const [isLoading, setIsLoading] = useState(false);
    const [isUpdate, setIsUpdate] = useState(false)
    const [CityOptions, setCityOptions] = useState([]);
    const [Countrypre, setCountrypre] = useState("")
    const [CountryOption, setCountryOption] = useState([]);
    const [SalesPerson, setSalesPerson] = useState([]);
    const [CustomerGroupOption, setCustomerGroupOption] = useState([]);
    const [PriceListOption, setPriceListOption] = useState([]);
    const [TerritoryOption, setTerritoryOption] = useState([]);
    const [PayTermsGrpOption, setPayTermsGrpOption] = useState([]);
    const [MenuText, setMenuText] = useState("Customer Master");

    const [tableData, setTableData] = useState({
        totalRecord: 0,
        gridData: [{
        }]
    })
    const [filterData, setFilterData] = useState({
        SearchFieldValue: "",
        SearchText: "",
        StartValue: "1",
        PageIndex: "1",
    })
    const [SaveData, setSaveData] = useState({
        CustomerID: "0",
        CustomerCode: "",
        CustomerName: "",
        SalesPerson: "",
        CustomerGroup: "",
        ZipCode: "",
        PhoneNo1: "",
        PhoneNo2: "",
        Fax: "",
        EmailID: "",
        Address: "",
        Country: "",
        CityName: "",
        Notes: "",
        CreditLimit: "0",
        CreditDays: "",
        Cellular: "",
        PriceListNum: "",
        Territory: "",
        PayTermGrp: "",
        Active: true
    });

    const handleClear = async () => {
        setSaveData({
            CustomerID: "0",
            CustomerCode: "",
            CustomerName: "",
            SalesPerson: "",
            CustomerGroup: "",
            ZipCode: "",
            PhoneNo1: "",
            PhoneNo2: "",
            Fax: "",
            EmailID: "",
            Address: "",
            Country: "",
            CityName: "",
            Notes: "",
            CreditLimit: "0",
            CreditDays:"",
            Cellular: "",
            PriceListNum: "",
            Territory: "",
            PayTermGrp: "",
            Active: true
        });

        setFilterData({
            ...filterData,
            SearchText: "",
            StartValue: "1",
            PageIndex: "1",
        });
        setIsUpdate(!isUpdate)

    }
    useEffect(() => {
        setTitle('CustomerMaster', setOpen);
        setFocus('txtCustomerCode')
        setTimeout(() => {
            setMenuText(document.title);
        }, 500)
    }, []);


    useEffect(() => {
        getCustomerData();
    }, [filterData.PageIndex, isUpdate]);

    const handleSubmit = () => {
        const loginCodeString = String(LoginUserCode);
        setIsLoading(true)
        let data = {
            ...SaveData, Token, LoginUserCode: loginCodeString
        }
        post(`${API_SERVER}/api/Master/InsertUpdateCustomerMaster`, { ...data }, (res) => {
            if ( res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false)
                handleClear();
                getCustomerData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            if (res.focus !== "" || res.status === 'ERROR') {
                AlertBox(res.status, res.message, res.focus)
                setFocus(res.focus)
            }
            setIsLoading(false)
        })
    }
    const getCustomerData = async (Type = 'S') => {
        const loginCodeString = String(LoginUserCode);
        const data = {
            ...filterData, Type: Type, Token, LoginUserCode: loginCodeString
        }
        setIsLoading(true)
        post(`${API_SERVER}/api/Master/ShowExCustomerData`, { ...data }, (res) => {
       
            if (res.status === 'SUCCESS') {
                const gridDataStr = res.gridData;
                const cleanedGridDataStr = gridDataStr.trim().replace(/\r\n/g, '');
                const gridDataJson = JSON.parse(cleanedGridDataStr);
                if (Type === 'S') {
                    setTableData({
                        ...tableData,
                        gridData: gridDataJson,
                        totalRecord: res.totalRecord
                    });
                }
                else {
                    exportToExcel(gridDataJson, 'CustomerMaster');
                }
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.totalRecord <= 0) {
                setTableData(
                    {
                        totalRecord: 0,
                        gridData: [{
                        }]

                    })
            }
            else if (res.message !== "" || res.status==="ERROR") {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false)
            }
            setIsLoading(false)
        })
    }
    const handleEditData = (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, CustomerID: ID
        }
        post(`${API_SERVER}/api/Master/EditCustomerData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                setIsLoading(false);
                const editRecordStr = res.editRecord;
                const cleanededitRecordStr = editRecordStr.trim().replace(/\r\n/g, '');
                const editRecordJson = JSON.parse(cleanededitRecordStr);
                setSaveData({
                    CustomerID: ID,
                    CustomerCode: editRecordJson[0]['CustomerCode'],
                    CustomerName: editRecordJson[0]['CustomerName'],
                    SalesPerson: editRecordJson[0]['SalesPerson'],
                    CustomerGroup: editRecordJson[0]['CustomerGroup'],
                    ZipCode: editRecordJson[0]['ZipCode'],
                    PhoneNo1: editRecordJson[0]['PhoneNo1'],
                    PhoneNo2: editRecordJson[0]['PhoneNo2'],
                    Fax: editRecordJson[0]['Fax'],
                    EmailID: editRecordJson[0]['EmailID'],
                    Address: editRecordJson[0]['Address'],
                    Country: editRecordJson[0]['Country'],
                    CityName: editRecordJson[0]['CityName'],
                    Notes: editRecordJson[0]['Notes'],
                    CreditLimit: editRecordJson[0]['CreditLimit'].toString(),
                    CreditDays: editRecordJson[0]['CreditDays'].toString(),
                    Cellular: editRecordJson[0]['Cellular'],
                    PriceListNum: editRecordJson[0]['PriceListNum'].toString(),
                    Territory: editRecordJson[0]['Territory'],
                    PayTermGrp: editRecordJson[0]['PayTermGrp'],
                    Active: (editRecordJson[0]['Active'] === 'YES' ? true : false)
                });
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
            }
            if (res.focus !== "") {
                setFocus(res.focus)
            }
            setIsLoading(false);
        })
    }
    const handleDeleteData = (ID) => {
        setIsLoading(true)
        const loginCodeString = String(LoginUserCode);
        let data = {
            Token, LoginUserCode: loginCodeString, CustomerID: ID
        }
        post(`${API_SERVER}/api/Master/DeleteCustomerData`, { ...data }, (res) => {
            if (res.status === 'SUCCESS') {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false);
                getCustomerData();
            }
            else if (res.message === "EXPIRED") {
                navigate('/Login')
            }
            else if (res.message !== "") {
                AlertBox(res.status, res.message, res.focus)
                setIsLoading(false);
            }
        })
    }
    const getSalesPerson = () => {
        setSalesPerson([]);
        let temp = {
            Type: "GetSalesPerson",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };
        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let salesPersonData = res.autoCompleteData || [];
                setSalesPerson(salesPersonData);
            } else {
                setSalesPerson([]);
            }
        });
    };
    const getCustomer = () => {
        setCustomerGroupOption([])
        let temp = {
            Type: "GetCustomerGroup",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        }
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token: Token, LoginUserCode: loginCodeString
        }

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CustomerDatalist = res.autoCompleteData || [];
                setCustomerGroupOption(CustomerDatalist);
            } else {
                setCustomerGroupOption([]);
            }
        });
    }
    const getCountry = () => {
        setCountryOption([]);
        let temp = {
            Type: "GetCountry",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CountryOptionData = res.autoCompleteData || [];
                setCountryOption(CountryOptionData);
            } else {
                setCountryOption([]);
            }
        });
    };
    const getCity = () => {
        setCityOptions([]);
        let temp = {
            Type: "GetCity",
            Prefix: "",
            ContextKey: Countrypre.split(':')[0].trim(),
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let CityData = res.autoCompleteData || [];
                setCityOptions(CityData);
            } else {
                setCityOptions([]);
            }
        });
    };
    const getPriceList = () => {
        setPriceListOption([]);
        let temp = {
            Type: "GetPriceList",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let PriceData = res.autoCompleteData || [];
                setPriceListOption(PriceData);
            } else {
                setPriceListOption([]);
            }
        });
    };
    const getTeratory = () => {
        setTerritoryOption([]);
        let temp = {
            Type: "GetTerritory",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let TerritoryData = res.autoCompleteData || [];
                setTerritoryOption(TerritoryData);
            } else {
                setTerritoryOption([]);
            }
        });
    };
    const getPayTerm = () => {
        setPayTermsGrpOption([]);
        let temp = {
            Type: "GetPayTermsGrp",
            Prefix: "",
            ContextKey: "",
            ContextKey2: ""
        };
        const loginCodeString = String(LoginUserCode);
        const data = {
            Token,
            LoginUserCode: loginCodeString
        };

        getCommonData({ ...data, ...temp }, (res) => {
            if (res && res.status === "SUCCESS") {
                let PayTerms = res.autoCompleteData || [];
                setPayTermsGrpOption(PayTerms);
            } else {
                setPayTermsGrpOption([]);
            }
        });
    };
    let PayTermsOptionArr = []
    for (let i = 0; i < PayTermsGrpOption.length; i++) {
        let mydata = PayTermsGrpOption[i]?.values
        PayTermsOptionArr.push(mydata)
    };
    let TerritoryOptionArr = []
    for (let i = 0; i < TerritoryOption.length; i++) {
        let mydata = TerritoryOption[i]?.values
        TerritoryOptionArr.push(mydata)
    };
    let PriceOptionArr = []
    for (let i = 0; i < PriceListOption.length; i++) {
        let mydata = PriceListOption[i]?.values
        PriceOptionArr.push(mydata)
    };
    let CountryOptionArr = []
    for (let i = 0; i < CountryOption.length; i++) {
        let mydata = CountryOption[i]?.values
        CountryOptionArr.push(mydata)
    };
    let CityOptionArr = []
    for (let i = 0; i < CityOptions.length; i++) {
        let mydata = CityOptions[i]?.values
        CityOptionArr.push(mydata)
    };
    let SalesPersonArr = []
    for (let i = 0; i < SalesPerson.length; i++) {
        let mydata = SalesPerson[i]?.values
        SalesPersonArr.push(mydata)
    };
    let CustomerArr = []
    for (let i = 0; i < CustomerGroupOption.length; i++) {
        let mydata = CustomerGroupOption[i]?.values
        CustomerArr.push(mydata)
    };
    const searchHandle = async () => {
        setFilterData({
            ...filterData,
            PageIndex: "1",
        })
        getCustomerData();
    }
    const handleDownloadExcel = async () => {
        getCustomerData('E');
    }

    return (
        <main id="main" className="main" style={open ? {} : { marginLeft: "0" }}>
            <section className="section dashboard">
                <div className="row">
                    <div className="col-lg-12">
                        <div className="content-box">
                            <div className="heading-box">
                                <div className="heading">
                                    <h6 className="m-0 font-weight-bold text-primary">{MenuText}</h6>
                                </div>
                            </div>
                            <div className="form-box service-content-area">
                                <div className="row align-items-end">
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Customer Code<span className="Required">*</span></label>
                                            <input
                                                disabled={SaveData.CustomerID !== "0" ? true : false}
                                                id='txtCustomerCode'
                                                type="text"
                                                maxLength="10"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtCustomerName')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Customer Code'
                                                value={SaveData.CustomerCode}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, CustomerCode: e.target.value.toLocaleUpperCase()
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Customer Name<span className="Required">*</span></label>
                                            <input
                                                id='txtCustomerName'
                                                type="text"
                                                maxLength="200"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtSalesPerson');
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Customer Name'
                                                value={SaveData.CustomerName}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, CustomerName: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                          
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCustomerGroup") };
                                                }}
                                                label='Sales Person'
                                                placeholder="Sales Person"
                                                maxLength='50'
                                                options={SalesPersonArr}
                                                id='txtSalesPerson'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getSalesPerson()}
                                                inputValue={SaveData.SalesPerson ? SaveData.SalesPerson : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setSaveData({
                                                        ...SaveData, SalesPerson: newInputValue
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtZipCode") };
                                                }}
                                                label='Customer Group'
                                                placeholder="Customer "
                                                maxLength='50'
                                                options={CustomerArr}
                                                id='txtCustomerGroup'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCustomer()}
                                                inputValue={SaveData.CustomerGroup ? SaveData.CustomerGroup : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setSaveData({
                                                        ...SaveData, CustomerGroup: newInputValue
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Zip Code</label>
                                            <input
                                                id='txtZipCode'
                                                type="text"
                                                maxLength="10"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtPhoneNo1')
                                                    };
                                                }}
                                                onKeyUp={(e) => {
                                                    Number(e.target.value);
                                                } }
                                                className="form-control"
                                                placeholder='Enter Zip Code'
                                                value={SaveData.ZipCode}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, ZipCode: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Phone No 1</label>
                                            <input
                                                id='txtPhoneNo1'
                                                type="text"
                                                maxLength="15"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtPhoneNo2')
                                                    };
                                                }}
                                                className="form-control Number"
                                                placeholder='Enter Phone No 1'
                                                value={SaveData.PhoneNo1}
                                                onChange={(e) => {
                                                    let { value } = e.target
                                                    const phoneNo1 = value.replace(/[^0-9]/g, '')
                                                    setSaveData({
                                                        ...SaveData, PhoneNo1: phoneNo1
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Phone No 2</label>
                                            <input
                                                id='txtPhoneNo2'
                                                type="text"
                                                maxLength="15"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtFax')
                                                    };
                                                }}
                                                className="form-control Number"
                                                placeholder='Enter Phone No 2'
                                                value={SaveData.PhoneNo2}
                                                onChange={(e) => {
                                                    let { value } = e.target
                                                    const phoneNo2 = value.replace(/[^0-9]/g, '')
                                                    setSaveData({
                                                        ...SaveData, PhoneNo2: phoneNo2
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Fax</label>
                                            <input
                                                id='txtFax'
                                                type="text"
                                                maxLength="20"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtEmailID')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Fax'
                                                value={SaveData.Fax}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Fax: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Email ID</label>
                                            <input
                                                id='txtEmailID'
                                                type="text"
                                                maxLength="50"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtAddress')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Email ID'
                                                value={SaveData.EmailID}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, EmailID: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Address</label>
                                            <input
                                                id='txtAddress'
                                                type="text"
                                                maxLength="250"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtCountry')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Address'
                                                value={SaveData.Address}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Address: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtCity") };
                                                }}
                                                label='Country'
                                                placeholder="Country"
                                                maxLength='50'
                                                options={CountryOptionArr}
                                                id='txtCountry'
                                                required={true}
                                                ignore_common={true}
                                                onFocus={() => getCountry()}
                                                inputValue={SaveData.Country ? SaveData.Country : ''}
                                                onInputChange={(event, newInputValue) => {
                                                    setSaveData({
                                                        ...SaveData, Country: newInputValue

                                                    })
                                                    setCountrypre(newInputValue)
                                                }
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtNotes") };
                                                }}
                                                label='City'
                                                placeholder="City"
                                                maxLength='50'
                                                options={CityOptionArr}
                                                id='txtCity'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getCity()}
                                                inputValue={SaveData.CityName ? SaveData.CityName : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, CityName: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Notes</label>
                                            <input
                                                id='txtNotes'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtCreditLimit')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Notes'
                                                value={SaveData.Notes}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Notes: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Credit Limit</label>
                                            <input
                                                id='txtCreditLimit'
                                                type="text"
                                                maxLength="10"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtCreditDays')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter CreditLimit'
                                                value={SaveData.CreditLimit}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, CreditLimit: Amount(e.target.value)
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Credit Days</label>
                                            <input
                                                id='txtCreditDays'
                                                type="text"
                                                maxLength="10"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtCellular')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Credit Days'
                                                value={SaveData.CreditDays}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, CreditDays: convertToNumber(e.target.value)
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <label className="form-label">Cellular</label>
                                            <input
                                                id='txtCellular'
                                                type="text"
                                                maxLength="100"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('txtPriceListNum')
                                                    };
                                                }}
                                                className="form-control"
                                                placeholder='Enter Cellular'
                                                value={SaveData.Cellular}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Cellular: e.target.value
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtTerritory") };
                                                }}
                                                label='Price List'
                                                placeholder="Enter Price List"
                                                maxLength='50'
                                                options={PriceOptionArr}
                                                id='txtPriceListNum'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getPriceList()}
                                                inputValue={SaveData.PriceListNum ? SaveData.PriceListNum : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, PriceListNum: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("txtPayTermGrp") };
                                                }}
                                                label='Territory'
                                                placeholder="Enter Territory"
                                                maxLength='50'
                                                options={TerritoryOptionArr}
                                                id='txtTerritory'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getTeratory()}
                                                inputValue={SaveData.Territory ? SaveData.Territory : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, Territory: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="fields">
                                            <AutoCompleteBox
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') { setFocus("chkActive") };
                                                }}
                                                label='Pay Terms Grp'
                                                placeholder="Enter Pay Terms Grp"
                                                maxLength='50'
                                                options={PayTermsOptionArr}
                                                id='txtPayTermGrp'
                                                required={false}
                                                ignore_common={true}
                                                onFocus={() => getPayTerm()}
                                                inputValue={SaveData.PayTermGrp ? SaveData.PayTermGrp : ''}
                                                onInputChange={(event, newInputValue) => setSaveData({
                                                    ...SaveData, PayTermGrp: newInputValue
                                                })
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-3 col-md-4 col-sm-6">
                                        <div className="form-check form-switch">
                                            <label
                                                className="form-check-label"
                                                htmlFor="activeCheckbox"
                                            >
                                                Active
                                            </label>
                                            <input
                                                className="form-check-input"
                                                type="checkbox"
                                                id="chkActive"
                                                onKeyDown={(e) => {
                                                    if (e.key === 'Enter') {
                                                        setFocus('btnSave')
                                                    };
                                                }}
                                                checked={SaveData.Active}
                                                onChange={(e) => {
                                                    setSaveData({
                                                        ...SaveData, Active: e.target.checked
                                                    })
                                                }}
                                            />
                                        </div>
                                    </div>
                                    <div className="col-lg-12 mt-1">
                                        <div className="lms-new-button text-center">
                                            {SaveData.CustomerID !== '0' ? (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                            </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Update
                                            </button>) : (isLoading ? <button className="button save-btn btn-disable" id='btnSave' disabled={isLoading} >
                                                Please wait...
                                                </button> : <button className="button save-btn" id='btnSave' onClick={handleSubmit}>
                                                <i className="bi bi-check-lg" /> Save
                                            </button>)}
                                            <button className="button export-btn" onClick={handleDownloadExcel}>
                                                <i className="bi bi-download" /> Export
                                            </button>
                                            <button className="button reset-btn" onClick={handleClear}>
                                                <i className="bi bi-arrow-clockwise" /> Reset
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <BindGrid tableData={tableData} setFilterData={setFilterData} filterData={filterData} searchHandle={searchHandle}  handleEditData={handleEditData} handleDeleteData={handleDeleteData} FormName='CustomerMaster' />
            
            {isLoading ? <Loader text='Please wait' size='100px' img_path='./assets/img/giphy.gif' /> : <></>}
          
        </main>
    )
}
export default CustomerMaster